import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastsHandoff } from '@/pages/workspaces/broadcasts/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy API-triggered tab URL. It forwards to the migrated list. The resolver belongs here:
 * this URL keeps the `journeys` segment, so a `/workspaces/last` sentinel resolves against the
 * embedded app's bundle before the forward builds its target.
 */
function JourneysBroadcastsApiTriggeredRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysBroadcastsHandoff tab="api-triggered" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/broadcasts/api-triggered')({
  component: JourneysBroadcastsApiTriggeredRoute,
});
